import axiosClient from "../axiosClient";

const route = "";

export const getMultiContainerInvoices = async (params = {}) => {
  try {
    const response = await axiosClient.get(
      `multiContainerInvoiceWithoutC/filteredMultiContainerInvoices`,
      {
        params: {
          ...params,
        },
      }
    );

    return response;
  } catch (error) {
    console.error(error);
  }
};

export const getAllBanks = async (params) => {
  try {
    const response = await axiosClient.get("api/bank", {
      params: {
        ...params,
      },
    });

    return response;
  } catch (error) {}
};

export const getCompanyBankAccounts = async (subCompanyId) => {
  try {
    const response = await axiosClient.get(`getBankAccounts`, {
      params: {
        subCompanyId: subCompanyId,
      },
    });

    return response;
  } catch (error) {
    console.error(error);
  }
};

export const getSupplierBankAccounts = async (supplierId) => {
  try {
    const response = await axiosClient.get(`getBankAccounts`, {
      params: {
        supplierId: supplierId,
      },
    });

    return response;
  } catch (error) {
    console.error(error);
  }
};

export const updateBankStatus = async ({ invoiceId, userId, bankStatus }) => {
  const response = await axiosClient.put(
    `/multiContainerInvoiceWithoutC/updateBankStatus/${invoiceId}`,
    { bankStatus: bankStatus }, // Request body (second parameter)
    {
      headers: {
        "user-id": userId,
      },
    } // Config with headers (third parameter)
  );
  return response;
};

/* Blocking endpoints */
export const checkIsBlocked = async (subCompanyId, bankId) => {
  try {
    const response = await axiosClient("subCompany/isBlocked", {
      subCompanyId: subCompanyId,
      bankId: bankId,
    });

    return response;
  } catch (error) {
    console.error(error);
  }
};

export const blockSubCompany = async (subCompanyId) => {
  try {
    const response = await axiosClient.post(
      `${route}/api/subCompany/toggleBlockSubcompany`,
      {
        subCompanyId,
      }
    );

    return response;
  } catch (error) {}
};
